/** @format */

import { createApi } from "@reduxjs/toolkit/query/react";
import BaseService from "./BaseService";

const axiosBaseQuery = () => async (request) => {
  try {
    // Assuming BaseService returns a promise
    const response = await BaseService(request);
    return { data: response.data };
  } catch (axiosError) {
    // Handle the case when BaseService throws an error
    const err = axiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

const RtkQueryService = createApi({
  reducerPath: "rtkApi",
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});

export default RtkQueryService;
